<template>
<div class="modal fade" id="StoreModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content p-0">
            <div class="d-flex" style="justify-content:space-between">
                <div class="sc-1mfkdot-1 lmvfJO p-4 pb-0"  >
                    <i class="bi bi-location-arrow pl-2"></i>
                        انتخاب شهر
                </div>
                <button type="button" class="btn-close p-4" data-bs-dismiss="modal" style="float:left" ></button>
            </div>
            <div class="sc-1trd2lw-0 inDgbR mb-3 mx-4" style="background: rgb(242, 247, 255);font-size: 1.2rem !important;padding-right: 0.8rem !important;border-radius: 0.5rem !important;border: none !important;font-size: 1rem;padding: 0.8rem 5px 0.8rem 0.8rem;"    >
                <div class="sc-19tkeot-0 dRqUMJ address-list-wrapper" >
                    <div class="flex-row align-center selected ">
                    <div role="radio" aria-checked="true" class="sc-19tkeot-1 gczbyG">
                        <span class="pr-1" style="font-size:.9em">
                            <span role="button" class="dp21x7-2 eFzfiL flex-row no-effect-button address-single-item">
                                شهر شما : 
                                <span class="sc-1t9q8tk-0 fAexS pr-2" style="max-height: 36px;">{{city[0].cityFa}}</span>
                            </span>
                        </span>
                    </div>
                    </div>
                </div>
            </div>
            <div class="dp21x7-0 bvfNtS no-select has-addresses mx-4 mb-3">
                <div class="sc-1trd2lw-0 dtVuHX">
                    <select class="form-control" style="appearance: auto;" disabled>
                        <option selected>تربت جام</option>
                    </select>
                </div>
                <small>با انتخاب شهرتان فروشگاه های همان شهر به شما نمایش داده میشود.</small>
                <small class="d-block text-danger">*ما در حال حاضر فقط در شهر تربت جام قادر به سرویس دهی هستیم.</small>
            </div>
        </div>
    </div>
</div>
</template>
<script setup> 
import { ref } from 'vue';
let city = ref();
getCityLocalStorage()
function getCityLocalStorage(){
    if(JSON.parse(localStorage.getItem('city'))){
		city.value = JSON.parse(localStorage.getItem('city'))
	}else{
        city.value = []
		city.value.push({
            city : 1,
            cityFa : 'تربت جام',
            cityEn : 'torbat jam'
        })
	}
}
</script>
<style scoped>
.jmXGlC .animate-visibility.visible {
    opacity: 1;
    max-height: 100vh;
    visibility: visible;
    transform: translateZ(0px) translateY(0px) scale(1);
    padding: 0px;
}
.jmXGlC .animate-visibility {
    will-change: transform, opacity, max-height, visibility;
    max-height: 0px;
    opacity: 0;
    overflow: hidden;
    visibility: collapse;
    transform: translateZ(0px) translateY(-1rem) scale(0.94);
    transition: transform 0.3s ease-in-out 0s, opacity 0.3s ease-in-out 0s, max-height 0.3s ease-in-out 0s, visibility 0.3s ease-in-out 0s;
}
.fHFHUJ.homeMode {
    top: 2.4rem;
    z-index: 1001 !important;
}
.fHFHUJ.visible {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.3s ease-in 0s, visibility 0.3s ease-in 0s !important;
    overflow: auto !important;
}

.GBeic.fixed {
    max-width: 100%;
}
.fHFHUJ {
    position: fixed;
    top: 6.8rem;
    right: 50%;
    will-change: opacity, visibility;
    opacity: 0;
    visibility: collapse;
    z-index: 995 !important;
    transform: translateZ(0px) translate(50%) !important;
    transition: opacity 0.2s ease-out 0s, visibility 0.2s ease-out 0s !important;
}
.GBeic {
    max-width: 1628px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 1.6rem;
    padding-right: 1.6rem;
    z-index: 1;
}
.fHFHUJ.homeMode > div {
    border-radius: 0.5rem;
    max-height: calc(100vh - 3.8rem) !important;
}
.fHFHUJ > div {
    position: relative;
    min-height: 39rem;
    background: rgb(255, 255, 255);
    border-radius: 0px 0px 0.5rem 0.5rem;
    display: flex;
    flex-direction: column;
    width: 67.8rem;
    max-height: calc(100vh - 4.2rem) !important;
}
.no-effect-button {
    display: flex;
    cursor: pointer;
    background: transparent;
    border: none !important;
}
.janmqm {
    border-bottom: 0.1rem solid rgb(238, 238, 238);
    padding: 2.2rem 2.2rem 0.8rem;
}
.lmvfJO {
    color: rgb(36, 70, 245);
    font-size: 1rem;
    font-weight: 500;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
}
.kYpmxj {
    padding: 1.6rem 2.2rem 2.2rem;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1 1 0%;
}
.jDBTBT {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0px;
    background-color: rgb(0, 0, 0);
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    z-index: 999;
    opacity: 0.75;
}
.jDBTBT > span {
    color: rgb(255, 255, 255);
    font-weight: 500;
    font-size: 1.6rem;
}

.lmvfJO .filter-items {
    display: flex;
    margin-right: auto;
}
.lmvfJO .filter-items button {
    min-width: unset;
    color: rgb(26, 28, 35);
    font-size: 1.2rem;
    border-radius: 1.2rem;
    margin-left: 0.4rem;
    font-weight: 500;
    display: flex;
    flex-direction: row-reverse;
}
.bEFLqK, .bEFLqK:hover, .bEFLqK:active, .bEFLqK:focus {
    border-color: transparent;
    background: none;
    box-shadow: unset;
    color: rgb(242, 247, 255);
}
.eofPpt {
    background: none;
    border: 0.1rem solid rgb(242, 247, 255);
    color: rgb(242, 247, 255);
}
.kiRutq {
    background-color: rgb(242, 247, 255);
    border: none;
    color: rgb(41, 41, 41);
}
.hmsHTb {
    background: none;
    border-radius: 0.5rem;
    font-family: IRANSansX;
    text-align: center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin: 0px;
    position: relative;
    user-select: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-decoration: none;
    overflow: hidden;
    vertical-align: middle;
    letter-spacing: 0px;
    cursor: pointer;
    outline: none;
    border: none;
    padding: 0px 1rem;
    height: 3rem;
    font-size: 1.4rem;
    min-width: 16rem;
    flex-direction: row;
}
.lmvfJO .filter-items button:last-child {
    margin-left: 0px;
}
.lmvfJO .filter-items button {
    min-width: unset;
    color: rgb(26, 28, 35);
    font-size: 1.2rem;
    border-radius: 1.2rem;
    margin-left: 0.4rem;
    font-weight: 500;
    display: flex;
    flex-direction: row-reverse;
}
.bEFLqK, .bEFLqK:hover, .bEFLqK:active, .bEFLqK:focus {
    border-color: transparent;
    background: none;
    box-shadow: unset;
    color: rgb(242, 247, 255);
}
.eofPpt {
    background: none;
    border: 0.1rem solid rgb(242, 247, 255);
    color: rgb(242, 247, 255);
}
.kiRutq {
    background-color: rgb(242, 247, 255);
    border: none;
    color: rgb(41, 41, 41);
}
.hmsHTb {
    background: none;
    border-radius: 0.5rem;
    font-family: IRANSansX;
    text-align: center;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    margin: 0px;
    position: relative;
    user-select: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-decoration: none;
    overflow: hidden;
    vertical-align: middle;
    letter-spacing: 0px;
    cursor: pointer;
    outline: none;
    border: none;
    padding: 0px 1rem;
    height: 3rem;
    font-size: 1.4rem;
    min-width: 16rem;
    flex-direction: row;
}
.inDgbR {
    overflow: auto;
    height: 100%;
}
.dtFLye {
    min-height: 15rem;
    padding-left: 0.1rem;
    margin-right: 0px !important;
    margin-left: 0px !important;
}
.cfwWbm {
    display: flex;
    flex-flow: row wrap;
    margin-left: -0.8rem;
    margin-right: -0.8rem;
    align-content: space-around;
    justify-content: center;
}
/* .OXPAn.selected {
    border: 0.1rem solid rgb(155 158 175);
} */
.OXPAn:nth-child(1) {
    margin-top: 0px !important;
}
@media (min-width: 768px)
{
    .OXPAn:nth-child(1), .OXPAn:nth-child(2) {
        max-height: 21rem;
        min-width: fit-content;
        /* margin-top: 0px !important; */
    }
}
.OXPAn:nth-child(1), .OXPAn:nth-child(2) {
    margin-top: 2.4rem;
}
@media (min-width: 768px)
{
    .OXPAn {
        width: calc(50% - 1.2rem) !important;
    }
}

.OXPAn {
    position: relative;
    cursor: pointer;
    width: 100%;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: rgb(0 0 0 / 4%) 0px 5rem 25rem 0px;
    border: 0.1rem solid rgb(238, 238, 238);
    display: flex;
    flex-direction: column;
    align-items: normal;
    -webkit-box-pack: justify;
    justify-content: space-between;
    margin-top: 2.4rem;
    padding: 0px !important;
    flex: 0 1 auto !important;
    margin-left: 0px !important;
}
@media (min-width: 0px)
{
    .hEbALF {
        max-width: 100%;
        flex: 0 0 100%;
        margin-right: 0%;
        order: unset;
    }
}

.hEbALF {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    position: relative;
    width: 100%;
}

.eBmsvk {
    background: url(https://snapp.market/v2/static/images/vendorCardBg.393d6e27.jpg) center center / 100% 100% no-repeat;
    min-height: 9rem;
}
.flex-column {
    display: flex !important;
    flex-direction: column !important;
}

.OXPAn.selected .vendor-logo {
    box-shadow: rgb(36 70 245) 0px 0px 0px 0.2rem;
}

.OXPAn .vendor-logo {
    margin-right: 1.6rem;
    margin-top: 1rem;
    width: 4.9rem;
    height: 4.9rem;
    box-shadow: rgb(0 0 0 / 10%) 0px 0.1rem 0.3rem 0px;
}
@media (min-width: 992px)
{

    .dBNnTd {
        width: 5.4rem;
        height: 5.4rem;
    }
}
@media (min-width: 768px)
{

    .dBNnTd {
        width: 4.5rem;
        height: 4.5rem;
    }
}

.dBNnTd {
    border-radius: 50%;
    margin-left: 0.8rem;
    box-shadow: rgb(0 0 0 / 40%) 0px 0.4rem 1.5rem -0.5rem;
    background-color: rgb(255, 255, 255);
    overflow: hidden;
    width: 3.2rem;
    height: 3.2rem;
    padding: 0.3rem;
}
.dBNnTd img {
    max-width: 100%;
    height: auto;
    display: block;
}
.dBNnTd img {
    max-width: 100%;
    height: auto;
    display: block;
}
.OXPAn.selected .card-footer {
    background: rgb(109 113 131);
}
.fHJBca {
    border-top: 0.1rem solid rgb(238, 238, 238);
    background: rgb(250, 250, 250);
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: .7rem;
    z-index: 99;
}
.OXPAn.selected .card-footer > div, .OXPAn.selected .card-footer > div span {
    color: rgb(255, 255, 255) !important;
}
.fHJBca div {
    color: rgb(117, 117, 117);
    font-size: 1rem;
}
.card-footer > div span {
    color: rgb(255, 255, 255) !important;
}
.fHJBca div span {
    color: rgb(26, 28, 35);
    font-size: 1rem;
    font-weight: 500;
}
.OXPAn.selected .card-footer > div, .OXPAn.selected .card-footer > div span {
    color: rgb(255, 255, 255) !important;
}
.fHJBca .free-delivery-message {
    margin-right: 0.6rem;
}


@media (min-width: 768px)
{

    .OXPAn:nth-child(2n) {
        margin-right: 2.4rem;
    }
}
.OXPAn:nth-child(2n) {
    margin-right: 0px;
    margin-top: 2.4rem;
    margin-left: 0px !important;
}

.OXPAn:nth-child(1), .OXPAn:nth-child(2) {
    margin-top: 2.4rem;
}
@media (min-width: 768px)
{

    .OXPAn {
        width: calc(50% - 1.2rem) !important;
    }
}

.OXPAn {
    position: relative;
    cursor: pointer;
    width: 100%;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: rgb(0 0 0 / 4%) 0px 5rem 25rem 0px;
    border: 0.1rem solid rgb(238, 238, 238);
    display: flex;
    flex-direction: column;
    align-items: normal;
    -webkit-box-pack: justify;
    justify-content: space-between;
    margin-top: 2.4rem;
    padding: 0px !important;
    flex: 0 1 auto !important;
    margin-left: 0px !important;
}
@media (min-width: 0px)
{

    .hEbALF {
        max-width: 100%;
        flex: 0 0 100%;
        margin-right: 0%;
        order: unset;
    }
}

.hEbALF {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    position: relative;
    width: 100%;
}

.eBmsvk.MYLI {
    background: url(https://radap.ir/panel/Backend/file/img/10-3-1024x683.jpg) center center / cover no-repeat;
}

.eBmsvk {
    background: url(https://radap.ir/panel/Backend/file/img/10-3-1024x683.jpg) center center / 100% 100% no-repeat;
    min-height: 9rem;
}
.OXPAn .vendor-logo {
    margin-right: 1.6rem;
    margin-top: 1rem;
    width: 4.9rem;
    height: 4.9rem;
    box-shadow: rgb(0 0 0 / 10%) 0px 0.1rem 0.3rem 0px;
}
@media (min-width: 992px)
{

    .dBNnTd {
        width: 5.4rem;
        height: 5.4rem;
    }
}
@media (min-width: 768px)
{

    .dBNnTd {
        width: 4.5rem;
        height: 4.5rem;
    }
}

.dBNnTd {
    border-radius: 50%;
    margin-left: 0.8rem;
    box-shadow: rgb(0 0 0 / 40%) 0px 0.4rem 1.5rem -0.5rem;
    background-color: rgb(255, 255, 255);
    overflow: hidden;
    width: 3.2rem;
    height: 3.2rem;
    padding: 0.3rem;
}
.janmqm .address-list-wrapper {
    max-height: 10rem;
}


.dRqUMJ {
    width: 100%;
}

.bvfNtS .address-list-wrapper > .flex-row.selected {
    background: rgb(242, 247, 255);
}

.bvfNtS .address-list-wrapper > .flex-row {
    border-bottom: 0.1rem solid rgb(250, 250, 250);
    padding: 0.8rem 0px 0.8rem 0.8rem;
}
.janmqm .flex-row {
    font-size: 1.2rem !important;
    padding-right: 0.8rem !important;
    border-radius: 0.5rem !important;
    border: none !important;
}
.gczbyG {
    display: flex;
    width: 100%;
    -webkit-box-align: center;
    align-items: center;
    opacity: 1;
    cursor: pointer;
}
.eBmsvk .off-label {
    padding: 0.7rem;
}

<style>
.OXPAn .off-label {
    background: rgb(255, 255, 255);
    color: rgb(36, 70, 245);
    position: absolute;
    top: 2rem;
    left: 1.6rem;
    font-size: 1.1rem;
}

.gsFXNJ {
    text-align: center;
    display: inline-block;
    margin: 0px;
    padding: 0.3rem 0.3rem 0.3rem !important;  
    background: white;
    color: rgb(42 40 219);
    vertical-align: middle;
    border: 0.1rem solid transparent;
    font-size: .8rem;
    border-radius: 4rem;
    font-weight: 600;
}
</style>